import React, { useEffect } from 'react';
import { Col, Row, Card, Button, Collapse, Alert } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
const Image1 = require("../assets/original/Final-1.jpeg");

const items = [
  {
    key: '2',
    label: "How do I know if my child is eligible?",
    children: <div>
      <h3>Students from Kindergarten-Year 2 are eligible if:</h3>
      <ul>
        <li>They are a resident of NSW, or an overseas student eligible for free government education 
        aged 4 years 6 months, or older.</li>
        <li>No minimum distance criteria applies to these students.</li>
      </ul>
      <p><strong>Note:</strong> Pre-school children are not eligible for subsidised travel between home and school under the SSTS</p>
      <h3>Primary school students from years 3-6 are eligible if:</h3>
      <ul>
        <li>They are a resident of NSW, or an overseas student eligible for free government education</li>
        <li>The straight line distance from their home address to school is 1.6 km or further.</li>
        <li>The walking distance from home to school is 2.3 km or further.</li>
      </ul>
      <p>Primary school students who live too close to the school to be eligible for free travel may purchase a Term Pass by contacting our office which provides bus travel at a discounted price.</p>
      <h3>Secondary school students from years 7-12 are eligible if:</h3>
      <ul>
        <li>They are a resident of NSW or an overseas student who is eligible for free government education</li>
        <li>the straight line distance from their home address to school is 2 kilometres, or further, or</li>
        <li>the walking distance from home to school is 2.9 kilometres or further.</li>
      </ul>
      <p>Secondary school students who live too close to the school to be eligible for free travel may purchase a Term Pass by contacting our office which provides bus travel at a discounted price.</p>
      <h3>TAFE students are eligible if:</h3>
      <ul>
        <li>They are a resident of NSW or an overseas student eligible for free government education</li>
        <li>They are under 18 years of age at 1 January of the year of application.</li>
        <li>They are enrolled in a full-time TAFE course for a minimum of 20 hours per week.</li>
        <li>They are not employed.</li>
        <li>The walking distance from home to TAFE is 3.2 km or further.</li>
        <li>They attend the closest TAFE where enrolment is available.</li>
      </ul>
      <h3>Non-Australian residents and students temporarily in Australia</h3>
      <p>Certain non-Australian residents and students temporarily in Australia are eligible for free or subsidised travel, depending on their visa subclass. You will need to quote your visa subclass number when applying for the SSTS, in addition to meeting the standard eligibility criteria.</p>
    </div>
  },
  {
    key: '3',
    label: "How do I apply for a Free Travel Pass?",
    children: <div>
      <p>You will need to submit a new application online if you are:</p>
      <ul>
        <li>applying for a school travel pass for the first time</li>
        <li>requesting an additional pass as a result of a new shared parental responsibility situation (e.g. joint custody).</li>
      </ul>
      <p>Please note that references to Opal Card do not apply to Rural and Regional areas, successful applicants will receive a Bus Pass from the bus operator.</p>
      <p>Before starting your application, you will need to know which bus operator(s) are required for the student's travel between home and school. If you are unsure please contact our office as selecting an incorrect bus operator will extend the process and delay when your child receives their bus pass.  If the bus operator is not on the list for selection please ensure you then select the “add another operator” option.</p>
      <p><strong>Please note you will need a valid email address to complete the online form.</strong> If you don't have access to the internet or an email address you will need to contact Transport for NSW on 131500 for assistance with the application.</p>
      <h3>Applying</h3>
      <ul>
        <li><strong>Step 1:</strong> Parents or students (aged 16 years or over) first fill in the online application form</li>
        <li><strong>Step 2:</strong> Note down your N or UN number</li>
        <li><strong>Step 3:</strong> Follow the steps provided on the screen to submit your application to your school for endorsement</li>
      </ul>
      <p><strong>School Endorsement</strong> - After you have submitted your online application, your school will then endorse the application.</p>
      <p><strong>Processing of Application</strong> - Transport for NSW will then review, approve and process your application</p>
      <p><strong>Issuing Free School Travel Passes</strong> - If the application is successful an email will be sent from Transport for NSW to you and the nominated bus operator that you chose during the application process. A school free travel pass will then be posted to your home/postal address that you nominated on the application.</p>
    </div>
  },
  {
    key: '4',
    label: "What if my application is unsuccessful?",
    children: <div>
      <p>Students who are not eligible for a school free travel pass can:</p>
      <ul>
        <li>purchase a School Term Pass from Picton Buslines</li>
        <li>pay a fare each time the bus is boarded</li>
        <li>request a review from Transport for NSW</li>
      </ul>
      <h3>How to request a review</h3>
      <p>You can request a review of your application under the following circumstances:-</p>
      <ul>
        <li>The pedestrian infrastructure between the student's home and school is unsuitable for safe walking. You need to include information on the walking route when applying for a review on pedestrian infrastructure grounds.</li>
        <li>The student has a medical condition which prevents them from walking to and from school. You need to include an SSTS Medical report and certificate when applying for an exemption on medical grounds.</li>
        <li>Legal/Child Services.  You need to include supporting documentation when applying for an exemption on Legal/Child Services grounds i.e. Police Report or Apprehended Violence Order (AVO)</li>
      </ul>
      <p>Initial applications on medical grounds may be approved for up to 12 months with a certificate from your general practiitioner. Subsequent applications require a more comprehensive report from a specialist how the condition prevents the student from walking to and from school. Subsidised travel on medical grounds does not apply to a one-off injury or a minor, temporary or irregular condition.</p>
      <h4>The Review Process</h4>
      <p>You can request a review online.</p>
      <p>Once you have completed your initial application and you receive notification that your application is unsuccesful and you feel that one of the above special circumstances apply to you, you can request a review by clicking on the 'Request a Review' link in your application status screen. Alternatively, you can request a review via the SSTS Website using your application ID number.</p>
      <p>Transport for NSW will assess each application on its individual merits.  It will take into account:</p>
      <ul>
        <li>The original assessment</li>
        <li>The walking route the student will travel from home to school.  This is assessed against the Guidelines for Determining the Safety of a Walking Route to School</li>
        <li>Any medical condition and supporting evidence</li>
      </ul>
      <p>If Transport for NSW determines that the student is eligible for a free travel pass under the SSTS, then a school travel pass will be issued to the student.</p>
    </div>
  },
  {
    key: '5',
    label: "How do I update my details?",
    children: <div>
      <p>If the student already has a bus pass and:</p>
      <ul>
        <li>is changing school or campuses</li>
        <li>is changing home address</li>
        <li>has received an expiry notification from Transport for NSW</li>
        <li>is repeating a school year</li>
        <li>has changed their name</li>
        <li>is requesting a new transport operator</li>
      </ul>
      <p>you will need to update their details online via the Transport for NSW SSTS Website. Please click here <a href='https://transportnsw.info/tickets-opal/ticket-eligibility-concessions/school-student-travel/update-school-travel-pass' target='_blank'><strong>UPDATE DETAILS</strong></a></p>
      <p>Transport for NSW will email you the outcome and if the update application is successful once it has been endorsed by the School, a new bus pass will be posted to you.</p>
      <p>You must return any bus pass to us that is no longer required or does not have the correct information.</p>
    </div>
  },
  {
    key: '6',
    label: "Can my child catch the bus while the application is being processed?",
    children: <div>
      <p><strong>Yes,</strong> when you complete your application you will receive an email from Transport for NSW confirming your application.  We will accept this confirmation of your application for a bus pass for 14 days from the date of the confirmation.</p>
      <p>After 14 days from the date of your application we may commence charging your child a fare, please contact our office for more information about this.</p>
    </div>
  },
  {
    key: '7',
    label: "What do I do if the pass is lost?",
    children: <div>
      <p>Replacement passes may be obtained at a cost of $15 by contacting our office.</p>
      <p><a href='https://lms-prod-media-assets.s3.ap-southeast-2.amazonaws.com/F1306_Application_for_Replacement_Pass_3412cb474d.pdf' target='_blank'>Click here</a> for a replacement pass form.</p>
    </div>
  },
  {
    key: '8',
    label: "Shared Parental Responsibility?",
    children: <div>
      <p>In a shared parental responsibility situation (e.g. joint custody), a student is eligible for subsidised travel from both the parents' addresses, subject to meeting the normal eligibility criteria.</p>
      <p>A separate online SSTS application should be made by each parent (or by the student if aged 16 or over) for each address. Applications for subsidised travel for Friday afternoons and Monday mornings only (to cover weekend access visits) are not eligible under the Scheme.</p>
      <p>You do not in the first instance need to provide a court order or statutory declaration to Transport for NSW for shared parental responsibility situations. However, Transport for NSW in its discretion reserves the right to request these or further evidence documents if required for the purposes of determining eligibility for subsidised travel from both parents' addresses.</p>
      <p>If you are in a shared parental responsibility situation where a School Pass has been approved and you change your address, you must submit an update application online.</p>
    </div>
  }
];

export default function SchoolTravel() {
  useEffect(() => {
    document.body.classList.add("PageSchoolTravel");
    return () => {
      document.body.classList.remove("PageSchoolTravel");
    };
  }, []);
  return (
    <div className="SchoolTravel PageSingle" style={{paddingBottom: "50px"}}>
      <section className="PageHero">
        <div className="AppContainer">
          <h1 className="title">Free School Travel</h1>
        </div>
      </section>
      <div className="AppContainer">
        <Row gutter={[20, 0]}>
          <Col xs={{span: 24, order: 2}} md={{span: 16, order: 1}}>
            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Free School Travel</h2>
              <p>If you already know you need to complete a new Transport for NSW online application please click APPLY NOW. Otherwise select from the options below for further information on the School Student Transport Scheme.</p>
              <h3>What is the School Student Transport Scheme (SSTS)?</h3>
              <p>It is a scheme administered by Transport for NSW in conjunction with schools and transport companies to enable eligible students to travel to and from school at no cost to the parents or guardians.</p>
            </Card>
            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Looking to renew or set up a school pass for your child? Follow the link here</h2>
              <Button target="_blank" href="https://transportnsw.info/tickets-fares/eligibility-concessions/school-student-travel">School Passes</Button>
            </Card>
            <Card bordered={false} className="CardItem">
              <Collapse accordion items={items} size="large" />
            </Card>
          </Col>
          <Col xs={{ span: 24, order: 1 }} md={{ span: 8, order: 2 }}>
            <Card bordered={false} className="CardItem Cover" bodyStyle={{ padding: 0 }} cover={<img alt="" src={Image1} />}></Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
